export default __webpack_public_path__ + "static/media/title_chayagai.1e926879.jpg";